export const questionType = {
  multiple: 'multiple',
  single: 'single',
};
